/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLeftSmallCuteFi: {
  name: 'left-small-cute-fi';
  data: string;
} = {
  name: 'left-small-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.555 7.74c-.624.2-2.115 1.46-2.935 2.481-.668.831-.829 1.176-.829 1.779s.161.948.829 1.779c.847 1.055 2.338 2.302 2.972 2.486.694.202 1.447-.147 1.761-.816.094-.201.107-.279.107-.629 0-.348-.014-.429-.104-.62-.127-.269-.325-.477-.717-.752a8.81 8.81 0 0 1-1.274-1.1l-.336-.352.336-.348a7.993 7.993 0 0 1 1.214-1.052c.452-.322.629-.504.77-.79.099-.201.111-.27.111-.626 0-.348-.013-.428-.104-.62a1.528 1.528 0 0 0-.702-.726c-.218-.107-.316-.131-.588-.141a1.606 1.606 0 0 0-.511.047"/></svg>`
};
